import { apiClient, setAuthToken } from "./apiClient";

export interface AppUser {
  email: string;
  name: string;
  role: "admin" | "user";
  permissions?: AppPermission[];
}

export type AppPermission = "admin" | "operator_automation" | "purchase_invoice_matching";

export const permissionLabels: Record<AppPermission, string> = {
  admin: "Käyttöoikeushallinta",
  operator_automation: "Saatavuuskyselyt",
  purchase_invoice_matching: "Laskudatan käsittely"
};

export function hasPermission(user: AppUser | null | undefined, permission: AppPermission) {
  if (!user) return false;
  if (user.permissions) return user.permissions.includes(permission);
  return user.role === "admin" || permission === "operator_automation";
}

export const authApi = {
  login: async (email: string, password: string) => {
    const result = await apiClient<{ token: string; user: AppUser }>("/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password })
    });
    setAuthToken(result.token);
    return result.user;
  },
  me: () => apiClient<{ user: AppUser }>("/auth/me"),
  changePassword: async (payload: { currentPassword: string; newPassword: string }) => {
    const result = await apiClient<{ token: string; user: AppUser }>("/auth/change-password", {
      method: "POST",
      body: JSON.stringify(payload)
    });
    setAuthToken(result.token);
    return result.user;
  },
  logout: () => setAuthToken(null)
};

export const usersApi = {
  list: () => apiClient<AppUser[]>("/users"),
  create: (payload: { email: string; name: string; password: string; permissions: AppPermission[] }) =>
    apiClient<AppUser>("/users", { method: "POST", body: JSON.stringify(payload) }),
  updateAccess: (email: string, payload: { name: string; permissions: AppPermission[] }) =>
    apiClient<AppUser>(`/users/${encodeURIComponent(email)}`, { method: "PATCH", body: JSON.stringify(payload) }),
  delete: (email: string) => apiClient<void>(`/users/${encodeURIComponent(email)}`, { method: "DELETE" })
};
